import { render, staticRenderFns } from "./Flag.vue?vue&type=template&id=3e7ebc85"
import script from "./Flag.vue?vue&type=script&lang=js"
export * from "./Flag.vue?vue&type=script&lang=js"
import style1 from "./Flag.vue?vue&type=style&index=1&id=3e7ebc85&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports